/**
 * "Nội dung này hiện cho ai" phía WEB — bản rút gọn của backend
 * services/audience-rules.js. Ô tiện ích lấy từ file tĩnh utility-blocks.json
 * (dùng chung cho mọi người) nên phải tự lọc ở client bằng thông tin user hiện tại.
 *
 * Giá trị phải khớp backend, lệch là ô biến mất hoặc hiện nhầm người.
 */

export const AUDIENCE_OPTIONS = [
    { value: 'all', label: 'Tất cả' },
    { value: 'guest', label: 'Khách chưa đăng nhập' },
    { value: 'logged_in', label: 'Đã đăng nhập' },
    { value: 'new_user', label: 'User mới' },
    { value: 'no_order', label: 'Chưa có đơn nào' },
    { value: 'has_order', label: 'Đã có đơn' },
];

const DEFAULT_NEW_USER_DAYS = 7;

/**
 * Ngữ cảnh người xem lấy từ redux auth.
 * hasOrder: getMe trả về; undefined (bản cũ/chưa tải xong) -> suy từ totalOrders nếu có.
 */
export function viewerFromAuth(isLogined, userInfo) {
    const u = userInfo || {};
    const hasOrder =
        typeof u.hasOrder === 'boolean'
            ? u.hasOrder
            : typeof u.totalOrders === 'number'
              ? u.totalOrders > 0
              : null;
    return {
        isLogined: !!isLogined,
        createTime: u.createTime != null ? Number(u.createTime) : null,
        hasOrder,
        now: Math.floor(Date.now() / 1000),
    };
}

/** Một mục (ô tiện ích/…) có hiện cho người xem này không. */
export function matchesAudience(item, viewer) {
    switch (item?.audience) {
        case 'guest':
            return !viewer.isLogined;
        case 'logged_in':
            return viewer.isLogined;
        case 'new_user': {
            if (!viewer.isLogined || !viewer.createTime) return false;
            const days = Number(item.audienceDays) > 0 ? Number(item.audienceDays) : DEFAULT_NEW_USER_DAYS;
            return viewer.now - viewer.createTime <= days * 86400;
        }
        // Chưa biết đã có đơn hay chưa (dữ liệu chưa về) -> KHÔNG đoán bừa, ẩn cho chắc
        case 'no_order':
            return viewer.isLogined && viewer.hasOrder === false;
        case 'has_order':
            return viewer.isLogined && viewer.hasOrder === true;
        default:
            return true; // 'all' hoặc giá trị lạ/bản ghi cũ
    }
}

export function filterByAudience(items, viewer) {
    return (items || []).filter((item) => matchesAudience(item, viewer));
}
